<template>
    <div class="microlearning-overview">
        <div :key="elementId" v-for="(microLearningElement, elementId) in groupedMicroLearningElements">
            <div class="microlearning-overview__section-title" :class="{ 'microlearning-overview__no-checkbox': !doesSectionsHaveVideos(microLearningElement) }">
                <span class="microlearning-overview__section-title-icon icon-cubes"></span>
                <span class="microlearning-overview__section-label">
                    {{ microLearningElement.title }}
                </span>
                <span
                    v-if="convertTimeToMinutesAndHoursForElement(microLearningElement)"
                    class="microlearning-overview__section-title-time"
                >
                    ({{ convertTimeToMinutesAndHoursForElement(microLearningElement) }})
                </span>
                <span
                    v-if="doesSectionsHaveVideos(microLearningElement)"
                    :class="['microlearning-overview__icon-completion', isElementCompleted(microLearningElement)]"
                >
                </span>
            </div>
            <MicroLearningOverviewItem
                v-for="(microLearningSection, index) in microLearningElement.sections"
                :key="index"
                :time="microLearningSection.duration"
                :title="microLearningSection.title"
                :sectionType="microLearningSection.type"
                :microLearningElementId="microLearningSection.elementId"
                v-on:reInitializeVideo="reInitializeVideo"
                :allCurrentlyWatchedSequences="allCurrentlyWatchedSequences"
                :isCompleted="isSectionCompleted(microLearningSection.elementId, microLearningSection.duration)"
                :section="microLearningSection"
            />
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import MicroLearningOverviewItem from 'components/coursepage/microlearning/overview/MicroLearningOverviewItem'
    import microLearningHelper from 'components/shared/mixins/microLearningHelper'
    import rangeHandler from 'helpers/rangeHandler'

    export default {
        name: 'MicroLearningOverview',
        components: {
            MicroLearningOverviewItem
        },
        mixins: [ microLearningHelper ],
        props: {
            course: Object,
            canCourseTestBeOpen: Boolean,
            courseWithoutTestCompleted: Boolean
        },
        computed: {
            ...mapGetters({
                allCurrentlyWatchedSequences: 'VideoPlayer/allWatchedSequences',
                currentSessionSequences: 'MicroLearning/getCurrentSessionSequences'
            })
        },
        methods: {
            reInitializeVideo () {
                this.$emit('reInitializeVideo')
            },
            isElementCompleted (microLearningElement) {
                if (microLearningElement.sections.filter(section => !this.isSectionCompleted(section.elementId, section.duration)).length > 0) {
                    return 'icon-square-o'
                } else {
                    return 'icon-check-square'
                }
            },
            doesSectionsHaveVideos (microLearningElement) {
                return microLearningElement.sections.filter(section => section.type === 'video').length > 0
            },
            isSectionCompleted (elementId, elementDuration) {
                if (this.isLabel || !this.currentSessionSequences[elementId] || elementDuration === undefined) {
                    return false
                }
                let videoTimeRange = [
                    0,
                    elementDuration || 99999999999999
                ]
                const currentWatched = rangeHandler.getOverlappingLength(this.currentSessionSequences[elementId], videoTimeRange)
                const progressPercent = Math.max(Math.round(currentWatched / elementDuration * 100))
                return progressPercent > 85
            }
        }
    }
</script>

<style lang="scss" scoped>
    .microlearning-overview {
        margin: 0 0 30px 0;

        &__section-title {
            display: flex;
            align-items: center;
            padding: 10px 30px;
            margin: 15px 0px 0px 0px;
            font-size: 1.8rem;
            font-family: Quicksand-Regular, sans-serif;
            background: $wild_sand;
        }

        &__no-checkbox {
            padding: 10px 68px;
        }

        &__section-title-icon {
            color: $orange;
            margin: 0 7px 0 0;
        }
        &__section-title-time {
            margin: 0 0 0 5px;
            color: $black;
        }
        &__section-label {
            font-family: Quicksand-Bold, sans-serif;
        }
        &__icon-completion {
            font-size: 1.8rem;
            margin-left: auto;
        }

        .icon-square-o:before, .icon-square:before {
            cursor: auto;
        }
    }
</style>
